import React, { FC } from 'react';
import { Card } from '@components/atoms/Card';
import { Typography, TypographyAppearanceVariants, TypographyTagVariants } from '@components/atoms/Typography';
import { Space } from '@components/atoms/Space';
import styles from './AuthenticationCard.module.css';

type AuthenticationCardSubComponents = {
    Divider: typeof Divider;
};

export interface AuthenticationCardProps {
    title: string;
    subtitle: string;
    children: JSX.Element;
}

export const AuthenticationCard: FC<AuthenticationCardProps> & AuthenticationCardSubComponents = ({
    title,
    subtitle,
    children,
}: AuthenticationCardProps) => {
    return (
        <Card classes={styles['authentication-card']}>
            <Typography
                align="center"
                tagVariant={TypographyTagVariants.h1}
                appearanceLevel={TypographyAppearanceVariants.level5}>
                {title}
            </Typography>

            <Space spaceBreakpoints={{ xs: { space: 15 } }} />

            <Typography align="center" fontSize="16" color="muted">
                {subtitle}
            </Typography>

            <Space spaceBreakpoints={{ xs: { space: 30 } }} />

            {children}
        </Card>
    );
};

interface DividerProps {
    text: string;
}

const Divider: FC<DividerProps> = ({ text }) => {
    return (
        <div className="d-flex w-100 justify-content-between" data-testid="divider-text">
            <hr className="my-2 w-100" />
            <Typography classes="d-grid mb-0 px-3 align-content-center text-nowrap" fontSize="12">
                {text}
            </Typography>
            <hr className="my-2 w-100" />
        </div>
    );
};

AuthenticationCard.Divider = Divider;
